export interface VendorRecord {
  _id?: string;
  vendorId: string;
  name: string;
  os: PatchOsType;
}

export interface ProductRecord {
  _id?: string;
  productId: string;
  name: string;
}

export interface Vendor {
  id: string;
  name: string;
}

export interface Product {
  id: string;
  name: string;
}

export interface VendorProductsPair {
  vendor: Vendor;
  products: Product[];
  os: PatchOsType;
}

export interface GridRow extends VendorProductsPair {
  actions: boolean;
}

export enum Column {
  VENDOR,
  PRODUCTS,
  ACTIONS,
}

export enum ColumnKeys {
  VENDOR = 'vendor',
  PRODUCTS = 'products',
  ACTIONS = 'actions',
}

export enum PatchOsType {
  WINDOWS = 1,
  LINUX = 2,
  MAC = 3,
}
